













import Vue from 'vue'
import { mapState } from 'vuex'
import BasicInfo from './Partial/BasicInfo.vue'
import EmailInfo from './Partial/EmailInfo.vue'
import PasswordInfo from './Partial/PasswordInfo.vue'
import XButton from '@/components/atoms/Button/XButton.vue'

export default Vue.extend({
  name: 'Profile',
  components: { BasicInfo, EmailInfo, PasswordInfo, XButton },
  computed: {
    ...mapState('auth', ['user']),
  },
  methods: {
    handleClick() {
      this.$router.push({ name: 'Account' })
    },
  },
})
